export const GET_TCPA_HISTORY = 'GET_TCPA_HISTORY';
export const SET_TCPA_HISTORY_STATUS = 'SET_TCPA_HISTORY_STATUS';